import React, { cloneElement } from 'react';
import {
  List,
  Datagrid,
  TextField,
  Show,
  Edit,
  TextInput,
  ShowButton,
  EditButton,
  SimpleShowLayout,
  SimpleForm,
  RefreshButton,
  CardActions,
  translate,
  Filter,
  FunctionField,
  TabbedShowLayout,
  Tab,
  ReferenceField,
  ListButton,
  DeleteButton,
  Toolbar,
  SaveButton
  // Texfield
} from 'react-admin';
import { ContributionTab } from '../contributions/ContributionTab';
// import { PageTitle } from './common';
import { Title } from '../components/Title';

import UserIcon from '../assets/SVGicon';
import { Pagination } from 'react-admin';

const paginationCompanies = 50;
const PostPagination = props => (
  <Pagination rowsPerPageOptions={[]} {...props} />
);

const UsersListActions = ({
  resource,
  filters,
  showFilter,
  displayedFilters,
  filterValues
}) => (
  <CardActions>
    {filters &&
      cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button'
      })}
    <RefreshButton />
  </CardActions>
);

const CompaniesFilter = props => {
  const { translate } = props;
  return (
    <Filter {...props}>
      <TextInput
        label={translate('resources.events.search')}
        // label="rechercher"
        source="searchQuery"
        alwaysOn
      />
    </Filter>
  );
};

const renderUsersNumber = ({ record, ...rest }) => {
  return record.users ? record.users.length : '0';
};

const renderContributionsNumber = ({ record }) => {
  let total = 0;
  if (record.users) {
    record.users.map(user => {
      return (total += user.missionIds ? user.missionIds.length : 0);
    });
  }
  return total;
};

let CompaniesList = props => {
  const { translate, options } = props;
  const { roleLevel } = options;

  return (
    <List
      // title={<PageTitle title={translate('resources.companies.name', 2)} />}
      title={<Title />}
      //title={<PageTitle title={translate('resources.companies.name', 2)} />}
      sort={{ field: 'name', order: 'ASC' }}
      perPage={paginationCompanies}
      actions={<UsersListActions />}
      bulkActionButtons={false}
      {...props}
      pagination={<PostPagination />}
      filters={<CompaniesFilter translate={translate} />}
      //pagination={null}
    >
      <Datagrid>
        <TextField
          source="name"
          // sortable={false}
        />
        <FunctionField
          label="Users"
          source="users"
          render={record => renderUsersNumber({ record })}
          sortable={false}
        />

        <FunctionField
          source="contributions"
          label="Contributions"
          render={record =>
            renderContributionsNumber({
              record
            })
          }
          sortable={false}
        />
        <ShowButton />
        {roleLevel > 0 && <EditButton />}
      </Datagrid>
    </List>
  );
};

let CompanyTitle = ({ record, translate }) => (
  <span>
    {`${translate('resources.companies.name', 1)}: `}
    {record && record.name
      ? `${record.name.substring(0, 1).toUpperCase() +
          record.name.substring(1)}`
      : ''}
  </span>
);

const renderUsers = ({ record, translate, ...rest }) => {
  return record.users && record.users.length > 0
    ? record.users.map(user => {
        return (
          <div
            key={user.id}
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            {user.photoURL ? (
              <img
                style={{
                  marginTop: 7,
                  marginRight: 10,
                  width: 40,
                  height: 40,
                  borderRadius: 40
                  //objectFit: 'contain'
                }}
                src={user.photoURL}
                alt="default"
              />
            ) : (
              UserIcon(40, {
                marginTop: 7,
                marginRight: 10,
                borderRadius: 40
                //objectFit: 'contain'
              })
            )}
            <ReferenceField
              label={translate('resources.users.name', 1)}
              source="id"
              reference="users"
              sortable={false}
              record={user}
              //data={user}
              allowEmpty
              linkType="show"
              {...rest}
              basePath="/users"
            >
              <TextField source="name" />
            </ReferenceField>
            <span
              style={{
                color: '#4caf50'
              }}
            >
              ({user.missionIds ? user.missionIds.length : 0})
            </span>
          </div>
        );
      })
    : translate('resources.companies.none', {
        field: translate('resources.users.name', 1).toLowerCase()
      });
};

const CompaniesShowActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      {roleLevel > 0 && <EditButton basePath={basePath} record={data} />}
      <ListButton basePath={basePath} /> <RefreshButton />
      {roleLevel > 1 && (
        <DeleteButton basePath={basePath} resource={resource} record={data} />
      )}
    </CardActions>
  );
};

let CompanyShow = props => {
  const {
    hasList,
    hasCreate,
    hasShow,
    hasEdit,
    basePath,
    translate,
    options,
    ...rest
  } = props;
  const { roleLevel } = options;

  return (
    <Show
      // title={<CompanyTitle />}
      title={<Title />}
      actions={
        <CompaniesShowActions resource={rest.resource} roleLevel={roleLevel} />
      }
      {...props}
    >
      <TabbedShowLayout>
        <Tab label={translate('resources.missions.details')}>
          <SimpleShowLayout>
            <TextField source="name" />
            <FunctionField
              label={translate('resources.companies.engagement')}
              render={record => {
                const companyName =
                  record.name.substring(0, 1).toUpperCase() +
                  record.name.substring(1);
                const contributionNumbers = renderContributionsNumber({
                  record
                });
                return record.users > 0
                  ? `${translate('resources.companies.engagementSentence', {
                      companyName: companyName,
                      contributionNumbers: contributionNumbers
                    })}`
                  : translate('resources.companies.none', {
                      field: translate(
                        'resources.companies.engagement'
                      ).toLowerCase()
                    });
              }}
              sortable={false}
            />
            <FunctionField
              label={translate('resources.users.name', 2)}
              render={record =>
                renderUsers({
                  record,
                  basePath,
                  translate
                })
              }
              sortable={false}
            />
          </SimpleShowLayout>
        </Tab>
        <Tab label={translate('resources.contributions.name', 2)}>
          <ContributionTab {...rest} />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

const CompaniesEditActions = ({ basePath, data, roleLevel, resource }) => {
  return (
    <CardActions>
      <ShowButton basePath={basePath} record={data} />
      <ListButton basePath={basePath} /> <RefreshButton />
      {roleLevel > 1 && (
        <DeleteButton basePath={basePath} resource={resource} record={data} />
      )}
    </CardActions>
  );
};

const CompanyEditToolbar = ({ record, ...rest }) => {
  return (
    <Toolbar {...rest}>
      <SaveButton label="ENREGISTRER" redirect="show" submitOnEnter={true} />
    </Toolbar>
  );
};

let CompanyEdit = props => (
  <Edit
    title={<CompanyTitle />}
    actions={
      <CompaniesEditActions
        resource={props.resource}
        roleLevel={props.options.roleLevel}
      />
    }
    {...props}
  >
    <SimpleForm toolbar={<CompanyEditToolbar />}>
      <TextInput source="name" />
    </SimpleForm>
  </Edit>
);

CompanyTitle = translate(CompanyTitle);
CompaniesList = translate(CompaniesList);
CompanyShow = translate(CompanyShow);
export { CompaniesList, CompanyEdit, CompanyShow };



// WEBPACK FOOTER //
// ./src/components/Companies.js